module.exports = {
  "container": {
    "width": 750
  },
  "mask": {
    "top": 0,
    "width": 750,
    "height": 1344,
    "justifyContent": "center",
    "alignItems": "center"
  },
  "dialog-box": {
    "backgroundColor": "#FFFFFF",
    "width": 558
  },
  "dialog-content": {
    "paddingTop": 36,
    "paddingBottom": 36,
    "paddingLeft": 36,
    "paddingRight": 36
  },
  "content-title": {
    "color": "#333333",
    "fontSize": 36,
    "textAlign": "center",
    "marginBottom": 24
  },
  "content-subtext": {
    "color": "#666666",
    "fontSize": 26,
    "lineHeight": 36,
    "textAlign": "center"
  },
  "dialog-footer": {
    "flexDirection": "row",
    "alignItems": "center",
    "borderTopColor": "#F3F3F3",
    "borderTopWidth": 1,
    "borderTop": "1px solid #F3F3F3"
  },
  "footer-btn": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "flex": 1,
    "height": 90
  },
  "cancel": {
    "borderRightColor": "#F3F3F3",
    "borderRightWidth": 1,
    "borderRight": "1px solid #F3F3F3"
  },
  "btn-text": {
    "fontSize": 36,
    "color": "#666666"
  },
  "no-prompt": {
    "width": 486,
    "alignItems": "center",
    "justifyContent": "center",
    "flexDirection": "row",
    "marginTop": 24
  },
  "no-prompt-icon": {
    "width": 24,
    "height": 24,
    "marginRight": 12
  },
  "no-prompt-text": {
    "fontSize": 24,
    "color": "#A5A5A5"
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-1f9fc24c!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-dialog/index.vue
// module id = 44
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28